import { Sentry } from './sentry'
import { isNetworkOnlyError, isAlwaysCaptureEvent, networkErrorMessageOf, NETWORK_BREADCRUMB_CATEGORY } from './networkError'

const isDev = import.meta.env.DEV

// 電話番号の消し込み(scrubPayload と breadcrumb の文言で共通)。
const PHONE_RE = /\b0[789]\d{8,9}\b/g
// D-1124 追補: 素の文字列(breadcrumb の message)用のメールの消し込み。JSON の中ではないので引用符を前提にしない。
const EMAIL_IN_TEXT_RE = /[^\s"'<>()@]+@[^\s"'<>()@]+\.[^\s"'<>()@]+/g

function scrubText(text) {
  if (typeof text !== 'string') return text
  return text.replace(EMAIL_IN_TEXT_RE, '[email]').replace(PHONE_RE, '[phone]')
}

function scrubPayload(payload) {
  if (typeof payload !== 'object' || !payload) return payload
  try {
    const s = JSON.stringify(payload)
      .replace(/"[^"]*@[^"]+\.[^"]+"/g, '"[email]"')
      .replace(PHONE_RE, '[phone]')
    return JSON.parse(s)
  } catch { return payload }
}

export const logger = {
  debug(event, payload) {
    if (isDev) console.debug(`[${event}]`, payload)
  },
  info(event, payload) {
    if (isDev) console.info(`[${event}]`, payload)
  },
  warn(event, payload) {
    console.warn(`[${event}]`, payload)
  },
  error(event, payload) {
    // D-1124: 通信断・圏外なだけ(アプリの不具合ではない)は Sentry に例外で送らない。
    //   breadcrumb に残し、後で本物のエラーが出たときに「直前に通信断があった」と文脈で見えるようにする。
    // D-1124 追補: ど安定 5 点の保存・送信の失敗(networkError.js の ALWAYS_CAPTURE_EVENTS)は、
    //   通信断でも今までどおり captureException する。判定より先に見て、下の従来の経路へそのまま流す。
    if (!isAlwaysCaptureEvent(event) && isNetworkOnlyError(payload)) {
      console.warn(`[${event}]`, payload)
      try {
        // D-1124 追補: breadcrumb の message / data.message にも scrubPayload と同じ消し込み(メール・電話)を通す。
        const message = scrubText(networkErrorMessageOf(payload))
        const extra = payload instanceof Error ? {} : scrubPayload(payload)
        Sentry.addBreadcrumb({
          category: NETWORK_BREADCRUMB_CATEGORY,
          level: 'warning',
          message: `${event}: ${message}`,
          data: { ...(typeof extra === 'object' && extra ? extra : {}), event, message },
        })
      } catch {}
      return
    }
    console.error(`[${event}]`, payload)
    try {
      Sentry.captureException(
        payload instanceof Error ? payload : new Error(event),
        { extra: { event, ...scrubPayload(payload) } }
      )
    } catch {}
  },
  fatal(event, payload) {
    console.error(`[FATAL:${event}]`, payload)
    try {
      Sentry.captureException(
        payload instanceof Error ? payload : new Error(event),
        { level: 'fatal', extra: { event, ...scrubPayload(payload) } }
      )
    } catch {}
  },
}
